import { Box, Button, Grid, Typography } from "@mui/material";
import Wrapper from "../components/layout/Wrapper";
import { NavLink, useParams } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import { useEffect } from "react";
import NAV from "../utils/nav.const";
import { useTranslation } from "react-i18next";

const VerifyAccount = () => {
  const { username, code } = useParams();
  const { confirmSignUp } = useUserAuth();
  const { t } = useTranslation();

  useEffect(() => {
    if (username && code) {
      confirmSignUp(username, code);
    }
  }, [username, code, confirmSignUp]);

  //TODO: continue here
  return (
    <Wrapper>
      <Box
        marginBottom={5}
        marginTop={4}
        sx={{
          marginLeft: { xs: "24px", md: 0 },
          backgroundColor: "#fff",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
          borderRadius: "16px",
        }}
        padding={3}
      >
        <Typography variant="h1">{t("verified.title")}</Typography>
        <Grid container marginTop="3rem">
          <Grid item xs={12} container gap={4}>
            <Typography variant="body1">{t("verified.subtitle")}</Typography>

            <Typography variant="body1">
              <strong>{t("verified.list-title")}</strong>
              <ul style={{ marginLeft: "2rem" }}>
                <li>{t("verified.list-item1")}</li>
                <li>{t("verified.list-item2")}</li>
                <li>{t("verified.list-item3")}</li>
              </ul>
            </Typography>

            <Typography variant="body1">{t("verified.questions")}</Typography>
          </Grid>
          <Box>
            <NavLink to={"/" + NAV.SIGNIN}>
              <Button
                style={{
                  marginTop: "2rem",
                }}
                variant="contained"
              >
                Log in
              </Button>
            </NavLink>
          </Box>
        </Grid>
      </Box>
    </Wrapper>
  );
};

export default VerifyAccount;
